<template>
	<div class="activeXP">
		<div class="banner">
			<div :class="{flexCentet:locale=='km'}" class="words">
				<div class="logo">
					<img :src="httpImg + `/activeXP/logo.png`" alt="">
					<div class="txet1" id="text">{{$t('activityXP.h1')}}</div>
				</div>
				<div class="txet2">
					<div class="txet2_1">$300,000</div>
					<div class="txet2_2" id="text">{{$t('activityXP.h2')}}</div>
				</div>
			</div>
			<img :src="httpImg +`/activeXP/bg1.png`" class="bg">
		</div>
		<div class="text3" id="text">
			{{$t('activityXP.activityTime')}}
			<div class="ding1"></div>
			<div class="ding2"></div>
			<div class="ding3"></div>
			<div class="ding4"></div>
		</div>


		<div class="text4">
			<div class="text4_1" id="text">{{$t('activityXP.activityRule')}}</div>
			<div class="text4_2" id="text">{{$t('activityXP.activityRuleDetail')}}</div>
		</div>
		<div class="text4">
			<div class="text4_1" id="text">{{$t('activityXP.exchangeRule')}}</div>
			<div class="text4_2" id="text">{{$t('activityXP.exchangeRuleDetail')}}</div>
			<img src="https://modu-oss-bucket-image-prod.oss-accelerate.aliyuncs.com/activeXP/usdt.png" alt=""
				class="icon">
		</div>
		<div class="text4">
			<div class="text4_1" id="text">{{$t('activityXP.exchangeType')}}</div>
			<div class="text4_2" id="text">{{$t('activityXP.exchangeTypeDetail')}}</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';
	// import Clipboard from 'clipboard'
	export default {
		data() {
			return {
				locale: '',
			}
		},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				httpImg: state => state.httpImg
			}),
		},
		created() {
			document.title = this.$t('activityXP.title');
			this.locale = this.$i18n.locale
		},

	}
</script>

<style scoped lang="less">
	.activeXP {
		min-height: 100vh;
		padding-bottom: 16px;
		background: #02081A;

		.banner {
			position: relative;
			height: 700px;

			.bg {
				width: 100%;
				/* 或指定具体的宽度 */
				height: auto;
				/* 保持图片原始高度 */
				object-fit: cover;
				/* 保持图片比例并覆盖整个容器 */
				position: absolute;
				top: 0;
				left: 0;
			}

			.words {
				position: absolute;
				z-index: 2;
				top: 0;
				left: 0;
				width: 100%;
			}

			.flexCentet {
				.txet2 {
					flex-direction: column;
					margin-top: 8px;

					.txet2_1 {
						font-size: 48px;
						line-height: 58px;
					}

					.txet2_2 {
						font-size: 40px;
						line-height: 56px;
					}
				}
			}

			.logo {
				padding-top: 164px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 20.54%;
					height: auto;
					object-fit: cover;
					margin-right: 16px;
				}
			}

			.txet1 {
				font-size: 40px;
				line-height: 56px;
				color: #fff;
				font-family: 'Medium';
			}

			.txet2 {
				font-size: 48px;
				line-height: 68px;
				margin-top: 16px;
				color: #fff;
				display: flex;
				justify-content: center;
				align-items: center;


				.txet2_1 {
					font-size: 56px;
					line-height: 68px;
					color: #FFCC00;
					font-family: 'Inter-SemiBold';
				}

				.txet2_2 {
					white-space: nowrap;
					margin-left: 8px;
					font-family: 'Semibold';
				}
			}

		}

		.text3 {
			display: inline-block;
			position: relative;
			height: 72px;
			padding: 0 36px;
			line-height: 72px;
			text-align: center;
			margin: 4px auto 64px;
			color: #fff;
			font-size: 26px;
			font-family: 'Medium';
			border: 2px solid #4e525f;

		}

		.ding1,
		.ding2,
		.ding3,
		.ding4 {
			width: 10px;
			height: 10px;
			background: #00C2E0;
			position: absolute;
			top: -5px;
			left: -5px;
		}

		.ding2 {
			top: unset;
			bottom: -5px;
		}

		.ding3 {
			background: #FFCC00;
			top: -5px;
			right: -5px;
			left: unset;
		}

		.ding4 {
			background: #FFCC00;
			top: unset;
			left: unset;
			bottom: -5px;
			right: -5px;
		}

		.text4 {
			position: relative;
			width: calc(100% - 8.54%);
			margin: auto;
			padding: 36px 24px;
			border-radius: 16px;
			background-color: rgba(255, 255, 255, .1);
			color: #fff;
			font-size: 24px;
			margin-bottom: 50px;
			text-align: left;
			line-height: 34px;

			.text4_1 {
				position: absolute;
				top: -16px;
				left: 24px;
				font-weight: 600;
				font-size: 26px;
				background-image: linear-gradient(to right, #FFFFFF 20%, #00C2E0 60%, #FFFFFF 70%);
				-webkit-background-clip: text;
				background-clip: text;
				color: transparent;
				/* 文字颜色设置为透明 */
				display: inline-block;
				/* 确保背景可以裁剪 */
			}

			.icon {
				width: 48.4px;
				height: 48px;
				position: absolute;
				top: -24px;
				right: 8px;
			}
		}
	}

	.activeXP::-webkit-scrollbar {
		height: 0px;
		/*滚动条高度*/
		width: 0px;
	}
</style>
<style scoped>
	/* 自定义字体包 */
	@font-face {
		font-family: 'Semibold';
		/* 你可以自定义这个名称 */
		src: url('https://modu-oss-bucket-image-prod.oss-accelerate.aliyuncs.com/activeXP/semibold.ttf') format('truetype');
	}

	@font-face {
		font-family: 'Inter-SemiBold';
		/* 你可以自定义这个名称 */
		src: url('https://modu-oss-bucket-image-prod.oss-accelerate.aliyuncs.com/activeXP/Inter-Bold.ttf') format('truetype');
	}

	@font-face {
		font-family: 'Medium';
		/* 你可以自定义这个名称 */
		src: url('https://modu-oss-bucket-image-prod.oss-accelerate.aliyuncs.com/activeXP/medium.ttf') format('truetype');
	}
</style>